import { Dialog } from '@cmsgov/ds-medicare-gov';
import React, { useEffect } from 'react';
import { useHistory, useLocation } from 'react-router-dom';
import Button from '../../common/components/button';
import { modalImpression } from '../analytics';
import translate from '../functions/translate';
import StackingButtons from './stacking.buttons';

const Popup = props => {
   const IsShowModal = props.showModal;
   const history = useHistory();
   let location = useLocation();
   let path;
   const routeName = location.pathname;
   const route = routeName.substring(routeName.indexOf('/') + 1);
   const pathName = route.endsWith('/') ? route.slice(0, -1) : route;
   
   const headerText = `${translate('Error')}: ${translate('Your session timed out')}`;

   useEffect(() => {
      if(IsShowModal){
         modalImpression(headerText);
      }
   }, [IsShowModal, headerText]);

   // match the translations we already have
   switch (pathName) {
      case 'forgot-password':
         path = 'Reset Password';
         break;
      case 'forgot-username':
         path = 'Get username';
         break;
      case 'create-account':
         path = 'Create Account';
         break;
      case 'login':
         path = 'Log in';
         break;
      case 'find-my-account':
         path = 'Find My Account';
         break;
      default:
         path = pathName.split("-").join(" ");
   }
   
   const getCancelButton = () => {
      return <>
         <Button
            color={'blue'}
            displayAs={'link'}
            fill={""}
            onClick={() => document.location.href = "http://www.medicare.gov"}
         >{translate('Cancel')}
         </Button>
      </>;
   };
   
   const getRestartButton = () => {
      return <>
         <Button
            color={'teal'}
            displayAs={'button'}
            fill={'solid'}
            onClick={() => history.push(routeName)}
            size={'small'}
         >{`${translate('Restart')} ${translate(toTitleCase(path))}`}</Button>
      </>;
   };
   
   const toTitleCase = (phrase) => {
      return phrase.charAt(0).toUpperCase() + phrase.slice(1);
   };
   
   return (
      <div>
         {IsShowModal &&
         <Dialog
            heading={headerText}
         >
            {`${translate('Please restart')} ${translate(toTitleCase(path))}`}
            <StackingButtons
               button1={getRestartButton()}
               button2={getCancelButton()}
            />
         </Dialog>
         }
      </div>
   );
};

export default Popup;
